// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";

// event-scheduler-video-conferencing-input imports
import { IContainer, IProps, IState } from "./EventSchedulerVideoConferencingInput.d";
import { styles, icon } from "./EventSchedulerVideoConferencingInput.styles";
import { VideoConferencingEnum } from "@components/event-scheduler";

import { CalloutBox } from "@components/callout-box";
import { A } from "@ui";

// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";

// util
// import { getCurrentOrg } from '@util/org.util';

// material-ui
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { Videocam } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";

///////////////
// Component //
///////////////
class EventSchedulerVideoConferencingInputCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      videoConferencing: props.includeZoomLink
        ? VideoConferencingEnum.Zoom
        : VideoConferencingEnum.None,
    };
  }

  private onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const videoConferencing = e.target.value as VideoConferencingEnum;
    this.setState({ videoConferencing });
    if (this.props.onChange) {
      switch (videoConferencing) {
        case VideoConferencingEnum.Zoom:
          this.props.onChange(true);
          break;
        case VideoConferencingEnum.GoogleMeet:
        case VideoConferencingEnum.None:
          this.props.onChange(false);
          break;
      }
    }
  };

  private onSettingsClick = () => {
    this.props.setSettingsDialogOpen(true);
  };

  public render() {
    const { classes, zoomAccount, zoomUserLevelAccount, primaryOrgCalendar } = this.props;

    // check if this user has a valid account on the organization's connected zoom account
    const canUseZoom = zoomUserLevelAccount || (zoomAccount && zoomAccount.hasValidZoomAccount);

    return (
      <div className={classes.container}>
        {canUseZoom ? (
          ""
        ) : (
          <CalloutBox warning>
            We can't find a Zoom account matching {primaryOrgCalendar}.{" "}
            <A onClick={this.onSettingsClick}>Zoom settings</A>
          </CalloutBox>
        )}
        <div className={classes.content}>
          <Videocam {...icon} />
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="cw-video-conferencing">
              Video conferencing
            </InputLabel>
            <Select
              value={this.state.videoConferencing}
              onChange={this.onChange}
              name="Video Conferencing"
              inputProps={{
                name: "Video Conferencing",
                id: "cw-video-conferencing",
              }}
              fullWidth
            >
              {canUseZoom ? (
                <MenuItem value={VideoConferencingEnum.Zoom}>Zoom Meeting</MenuItem>
              ) : (
                ""
              )}
              {/* <MenuItem value={VideoConferencingEnum.GoogleMeet}>Google Meeting</MenuItem> */}
              <MenuItem value={VideoConferencingEnum.None}>No video conferencing</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const EventSchedulerVideoConferencingInputStyled = withStyles(styles)(
  EventSchedulerVideoConferencingInputCmpt,
);

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const EventSchedulerVideoConferencingInput = connect(mapStateToProps, {
  setSettingsDialogOpen,
})(EventSchedulerVideoConferencingInputStyled);
